import axios from "axios";
import User from "shared/types/user.model";

const USER_ENDPOINT = "/users";
const ACCOUNT_ENDPOINT = "/account";

export interface ChangePassword {
	userId: number,
	oldPassword: string,
	newPassword: string,
	newPassword2: string
}

export const authenticate = (
	email: string,
	password: string,
	remeberMe: boolean
) =>
	axios.post("/authentication", {
		email: email,
		password: password,
		rememberMe: remeberMe
	});

export const listUsers = () => axios.get(USER_ENDPOINT);

export const getUser = (id: number) => axios.get(`${USER_ENDPOINT}/${id}`);

export const createUser = (user: User) => axios.post(USER_ENDPOINT, user);

export const updateUser = (user: User) => axios.put(USER_ENDPOINT, user);

export const getAccount = () => axios.get(ACCOUNT_ENDPOINT);

export const updateAccount = (user: User) => axios.post(ACCOUNT_ENDPOINT, {
	id: user.id,
	email: user.email,
	name: user.name
});

export const logout = (token: string) => axios.get(`${ACCOUNT_ENDPOINT}/logout/${token}`);

export const changePassword = (password: ChangePassword) =>
	axios.post(`${ACCOUNT_ENDPOINT}/password`, password);

export const activateAccount = (token: string, password: string) =>
	axios.post(`${ACCOUNT_ENDPOINT}/activate`, { token, password });

export const forgottenPasswordStart = (email: string) =>
	axios.post(`${USER_ENDPOINT}/forgotten`, { email });

export const forgottenPasswordEnd = (data: any = {}) =>
	axios.post(`${USER_ENDPOINT}/forgotten/finish`, data);

export const forgottenPasswordCancel = (data: any = {}) =>
	axios.post(`${USER_ENDPOINT}/forgotten/cancel`, data);
